import i18next from "i18next"

/** Intl locale for the active portal language (`en` / `sa`). */
export const getAppIntlLocale = () => {
  const lang = i18next.language || localStorage.getItem("I18N_LANGUAGE") || "en"
  return lang === "sa" ? "ar-SA" : "en-US"
}

/**
 * Translated AM/PM for 12-hour display.
 * @param {number|boolean} hoursOrIsPm - 0–23 hour, or boolean `true` for PM
 */
export const getTranslatedMeridiem = hoursOrIsPm => {
  const isPm =
    typeof hoursOrIsPm === "boolean"
      ? hoursOrIsPm
      : Number(hoursOrIsPm) >= 12
  return i18next.t(isPm ? "PM" : "AM")
}

/**
 * 12-hour time with Latin digits (0-9) and locale-translated AM/PM (ص/م).
 * Avoids ar-SA numeral conversion on chart labels.
 */
export const formatLocale12HourTime = (date, { padHour = false } = {}) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return ""
  let hours = date.getHours()
  const minutes = String(date.getMinutes()).padStart(2, "0")
  const meridiem = getTranslatedMeridiem(hours)
  hours = hours % 12 || 12
  const hourStr = padHour ? String(hours).padStart(2, "0") : String(hours)
  return `${hourStr}:${minutes} ${meridiem}`
}
